import { createContext, useContext } from 'react';
import type { ListViewRowContextValue } from './listView.types';

const EMPTY_MAP = new Map();
const EMPTY_HIGHLIGHTS: ListViewRowContextValue['highlightTerms'] = { searchTerm: '', hasWords: [], hasPhrase: '' };
const EMPTY_DENSITY: ListViewRowContextValue['density'] = {
  cellPaddingY: 2,
  cellPaddingX: 6,
  rowMinHeight: 28,
  fontSize: '0.75rem',
  headerFontSize: '0.625rem',
  thumbWidth: 0,
  thumbHeight: 0,
};

export const ListViewRowContext = createContext<ListViewRowContextValue>({
  rowType: 'asset',
  fieldsBySlug: EMPTY_MAP,
  loading: false,
  highlightTerms: EMPTY_HIGHLIGHTS,
  density: EMPTY_DENSITY,
  classes: {},
  handleNavigate: () => {},
});

export function useListViewRowContext(): ListViewRowContextValue {
  return useContext(ListViewRowContext);
}
